var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_00000007420653683276137850000006198260641501518244_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 187.1 187.1",
    style: {
      enableBackground: "new 0 0 187.1 187.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 745.4398,
    x2: 187.2,
    y2: 745.4398,
    gradientTransform: "matrix(1 0 0 1 0 -651.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006496"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.6,187.1C42,187.1,0,145.1,0,93.6S42,0,93.6,0s93.6,42,93.6,93.6S145.1,187.1,93.6,187.1z M93.6,8.3 c-47,0-85.2,38.2-85.2,85.2s38.2,85.2,85.2,85.2s85.2-38.2,85.2-85.2S140.5,8.3,93.6,8.3L93.6,8.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x39_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.6,58.9c0.2-0.5,0.3-1,0.1-1.6l-2.8-8.6c-0.5-1.5-1.5-2.7-2.9-3.4c-1.4-0.7-3-0.8-4.5-0.4L54.1,66.6 c-1.1,0.3-1.7,1.5-1.3,2.6l3.9,12c0,69.1,0,52.9,0,55.4c0,3.3,2.6,5.9,5.9,5.9h66c3.3,0,5.9-2.6,5.9-5.9c0-10,0-32.6,0-55.3 c0-1.1-0.9-2-2-2h-62l59-19.2C129.9,59.8,130.4,59.4,130.6,58.9z M103.9,63.9l-5.6-7.5l10.5-3.4l5.6,7.5L103.9,63.9z M89.3,68.7 l-5.6-7.5l10.5-3.4l5.6,7.5L89.3,68.7z M74.6,73.5L69.1,66l10.5-3.4l5.6,7.5L74.6,73.5z M65,67.3l5.6,7.5L60,78.2l-2.7-8.4 L65,67.3z M87.6,83.2l-4.3,12.6H72.2l4.3-12.6H87.6z M103,83.2l-4.3,12.6H87.6l4.3-12.6H103z M118.4,83.2l-4.3,12.6H103l4.3-12.6 H118.4z M67.9,95.8h-7.2V83.2h11.5L67.9,95.8z M130.4,136.5c0,1-0.8,1.8-1.8,1.8h-66c-1,0-1.8-0.8-1.8-1.8V99.8h69.6V136.5z  M130.4,95.8h-11.9l4.3-12.6h7.6V95.8z M118.5,59.2l-5.6-7.5l8.8-2.9c0.5-0.2,1-0.1,1.4,0.1c0.4,0.2,0.8,0.6,0.9,1.1l2.2,6.6 L118.5,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.2,115.4l-10.2-7c-1.4-0.9-3.2-1-4.6-0.3c-1.5,0.8-2.4,2.3-2.4,4V126c0,1.7,0.9,3.2,2.4,4c1.5,0.8,3.3,0.7,4.6-0.3 l10.2-7c1.2-0.8,2-2.2,2-3.7C105.1,117.6,104.4,116.2,103.2,115.4z M100.9,119.4l-10.2,7c-0.1,0.1-0.3,0.1-0.4,0 c-0.2-0.1-0.2-0.2-0.2-0.4v-13.9c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.1,0.4,0l10.2,7c0.2,0.1,0.2,0.3,0.2,0.4 C101.1,119.2,101,119.3,100.9,119.4z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.fbab1f7800dbfbd1518ec13dbe3c2197.svg";
export { ForwardRef as ReactComponent };